/* @Author: 李文 
 * @Date: 2020-12-21
 * @Last Modified by:   李文  */
import React from 'react';
import { connect } from 'react-redux';
import { Button, Input, Table, Pagination, Empty, Spin, Modal, message } from 'antd';
import * as actions from '../../actions/selectResourceData';
import _ from 'lodash';
import "./selectResourceData.scss";
import Scrollbars from 'react-custom-scrollbars';

const { Search } = Input;
const { confirm } = Modal;
const dataSource = [
    {
        key: '1',
        index: '1',
        name: '胡彦斌',
        sort: 32,
        type: '西湖区湖底公园1号',
    },
    {
        key: '2',
        index: '2',
        name: '胡彦祖',
        sort: 42,
        type: '西湖区湖底公园1号',
    },
];
class SelectResourceData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 1,
            pageSize: 10,
            total: 0,
            modalTitle: '新增来源',
            visible: false,
            loading: false,
            list: [],
            sourceName: '',
            sourceId:0,
            queryStr:'',
        }
    }

    componentDidMount(){
        this.getList(1);
    }

    getList = (page) => {
      //调用查询接口,查询列表数据  loading list total
      const { pageSize, queryStr} = this.state;
      actions.getResource({start:page, size: pageSize, name: queryStr },(res) => {
         if(res.status === 200){
             this.setState({
                 list: res.data.data,
                 total: res.data.count
             })
         }
      })
    }

    getColumns = () => {
        return (
            [
                {
                    title: '序号',
                    dataIndex: 'index',
                    key: 'index',
                    render:(text,record, index) => (this.state.current - 1)*this.state.pageSize + (index+1)
                },
                {
                    title: '名称',
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: '排序值',
                    dataIndex: 'sort',
                    key: 'sort',
                },
                {
                    title: '类型',
                    dataIndex: 'type',
                    key: 'type',
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    key: 'action',
                    render: (text, record, index) => {
                        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
                        return (
                            <div>
                                <span style={{ marginRight: 20, cursor: 'pointer', color: newSecondSelectColor }} onClick={() => this.edit(record)}>编辑</span>
                                <span style={{ cursor: 'pointer', color: newSecondSelectColor }} onClick={() => this.del(record)}>删除</span>
                            </div>
                        )
                    }
                }
            ]
        )
    }

    edit = (record) => {
        this.setState({
            sourceName: record.name,
            sourceId:record.id,
            visible: true,
            modalTitle: '编辑来源'
        })
    }

    del = (record) => {
        let _this = this;
        confirm({
            title: '确定删除此来源吗？',
            onOk() {
                //调用删除接口
                actions.delResource({id: record.id}, (res) => {
                    if(res.status === 200){
                        message.success('删除成功！');
                        _this.getList(1);
                        _this.setState({
                            current: 1
                        })
                    }else{
                       message.error(res.msg)
                    }  
                })
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    add = () => {
        this.setState({
            sourceName: '',
            sourceId: 0,
            visible: true,
            modalTitle: '新增来源'
        })
    }

    onSearch = (queryStr) => {
        console.log(queryStr)
        this.setState({
            queryStr,
        }, () => {
            this.getList(1)
        })

    }

    save = () => {
        const { modalTitle, sourceName, sourceId } = this.state;
        if(modalTitle === '新增来源'){
            //调用新增接口
            let params = { name: sourceName}
            actions.addResource(params,(res) =>{
                if(res.status === 200){
                    message.success('添加成功！')
                }else{
                   message.error(res.msg)
                }
                this.getList(1);
                this.setState({
                    visible: false,
                    current:1
                })
            })
        } else {
            //调用编辑接口
            let params = { name: sourceName, id:sourceId }
            actions.editResource(params,(res) =>{
                if(res.status === 200){
                    message.success('编辑成功！')
                }else{
                   message.error(res.msg)
                }
                this.getList(1);
                this.setState({
                    visible: false,
                    current:1
                })
            })
        }
    }

    changeValue = (e) => {
        this.setState({
            sourceName: e.target.value
        })
    }

    changePage = (current) => {
        this.setState({
            current
        }, ()=> {
            this.getList(current)
        })
    }

    render() {
        const { current, pageSize, total, modalTitle, visible, loading, list, sourceName, queryStr } = this.state;
        let height = window.innerHeight - 90;
        console.log(list)
        return (
            <>
                <div className="select-resource-data" style={{ height }}>
                    <div className="option">
                        <Button type="primary" onClick={() => this.add()}>添加</Button>
                        <Search placeholder="" value={queryStr} onChange={(e) => this.setState({ queryStr: e.target.value})} style={{ width: '300px', marginLeft: '20px' }} onSearch={(value) => this.onSearch(value)} enterButton />
                    </div>
                    <div className="wrap">
                        <Scrollbars>
                        {
                            loading ? <div className="center"><Spin /></div> : (
                                list.length === 0 ? <div className="center"><Empty /></div> :
                                    <>
                                        <div className="table">
                                            <Table
                                                dataSource={list}
                                                columns={this.getColumns()}
                                                bordered
                                                pagination={false}
                                            />
                                        </div>
                                        <div className="pagination">
                                            <Pagination
                                                current={current}
                                                pageSize={pageSize}
                                                total={total}
                                                onChange={(page) => this.changePage(page)}
                                            />
                                        </div>
                                    </>
                            )
                        }
                        </Scrollbars>
                    </div>
                </div>
                <Modal
                    title={modalTitle}
                    visible={visible}
                    onOk={this.save}
                    onCancel={() => this.setState({ visible: false })}
                    destroyOnClose
                    className="resource-data-modal"
                >
                    <div className="content">
                        <div>
                            <span>来源名称：</span>
                            <Input value={sourceName} onChange={(e) => this.changeValue(e)}/>
                        </div>
                        {/* <div>
                            <span>排序值：</span>
                            <Input value={selectItem.sort} onChange={(e) => this.changeValue(e,'sort')}/>
                        </div>
                        <div>
                            <span>类型：</span>
                            <Input value={selectItem.type} onChange={(e) => this.changeValue(e,'type')}/>
                        </div> */}
                    </div>
                </Modal>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
    }
}

export default connect(mapStateToProps)(SelectResourceData);